module.exports = __webpack_public_path__ + "static/us-flag-icon-ea4d28097f024a96ec22d20a6e354943.svg";